import { cn } from '@/lib/utils'

interface OnlineIndicatorProps {
  online: boolean
  className?: string
}

export function OnlineIndicator({ online, className }: OnlineIndicatorProps) {
  return (
    <span
      className={cn(
        'inline-block h-2.5 w-2.5 rounded-full border-2 border-background',
        online ? 'bg-emerald-500' : 'bg-gray-300 dark:bg-gray-600',
        className
      )}
      title={online ? 'En línea' : 'Desconectado'}
    />
  )
}
